import { render, staticRenderFns } from "./comp-im-pc.vue?vue&type=template&id=391184ed&scoped=true&lang=pug&"
import script from "./comp-im-pc.vue?vue&type=script&lang=js&"
export * from "./comp-im-pc.vue?vue&type=script&lang=js&"
import style0 from "./comp-im-pc.vue?vue&type=style&index=0&id=391184ed&prod&lang=stylus&scoped=true&"
import style1 from "./comp-im-pc.vue?vue&type=style&index=1&id=391184ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391184ed",
  null
  
)

/* custom blocks */
import block0 from "./comp-im-pc.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports